module.exports = __webpack_public_path__ + "img/logo.92b1f1ab.jpg";